import { useState } from "react";
import { useTranslation } from "react-i18next";
import Sidebar from "./Sidebar";
import { useWorkshop } from "../context/useWorkshop";
import { useSettings } from "../context/useSettings";

// Casca visual do módulo: sidebar + área de conteúdo. As variáveis de tema
// (cor primária / claro-escuro) são aplicadas apenas dentro deste wrapper
// (via style/data-attribute no próprio elemento raiz), nunca em
// document.documentElement — assim o módulo não "vaza" estilos globais
// quando embutido dentro do painel administrativo existente.
//
// Em telas estreitas (celular/tablet em pé), o menu lateral vira uma
// gaveta deslizante (aberta via botão hamburguer), em vez de uma barra
// horizontal apertada — evitando qualquer disputa de espaço com outros
// elementos fixos da pagina (ex.: botao "Voltar ao Painel").
export default function AppShell({ active, onNavigate, children }) {
  const { t } = useTranslation();
  const { workshopName } = useWorkshop();
  const { settings } = useSettings();
  const [menuMobileAberto, setMenuMobileAberto] = useState(false);

  return (
    <div
      className="checklist-app"
      data-checklist-theme={settings.theme}
      data-checklist-wallpaper={settings.wallpaperKey || "solido"}
      style={{
        "--checklist-primary": settings.primaryColor,
        "--checklist-bg-custom": settings.backgroundColor,
      }}
    >
      <button
        type="button"
        className="checklist-app__menu-toggle"
        onClick={() => setMenuMobileAberto(true)}
        aria-label={t("checklist.abrir_menu")}
      >
        ☰
      </button>
      <div className="checklist-app__layout">
        <Sidebar
          active={active}
          onNavigate={onNavigate}
          workshopName={workshopName}
          logoUrl={settings.logoUrl}
          features={settings.features}
          mobileOpen={menuMobileAberto}
          onCloseMobile={() => setMenuMobileAberto(false)}
        />
        <main className="checklist-app__content">{children}</main>
      </div>
    </div>
  );
}
